import Adapter from "./adapter";

export default Adapter;
